export const PRIMARY_COLOR = '#1e88e5'
export const SECONDARY_COLOR = '#ff9800'
export const BACKGROUND_COLOR = '#f4f6f8'
export const TEXT_PRIMARY = '#212121'
export const TEXT_SECONDARY = '#757575'
export const PAPER_COLOR = '#fff'
